import { render } from "./OldStudentData.vue?vue&type=template&id=22bd51ca&scoped=true"
import script from "./OldStudentData.vue?vue&type=script&lang=js"
export * from "./OldStudentData.vue?vue&type=script&lang=js"

import "./OldStudentData.vue?vue&type=style&index=0&id=22bd51ca&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bd51ca"]])

export default __exports__